import type { SettingsCategory } from "@/zustand/NavigationState";

/**
 * i18n label keys for the settings categories — shared by the flat settings
 * menu (SettingsView) and the middle-column shell (SettingsCategoryView) so
 * the two can never drift.
 *
 * t() must receive LEAF keys: `t("appearance")` returns an object (the
 * namespace), which crashes rendering — hence the explicit map instead of
 * `t(category)`.
 */
export const CATEGORY_LABEL_KEY: Record<SettingsCategory, string> = {
  profile: "profile.title",
  security: "security",
  appearance: "appearance.title",
  language: "language",
  preferences: "preferences",
};
